<template>
  <div id="app">
    <app-header></app-header>
    <router-view :key="Key" />
    <app-footer></app-footer>
  </div>
</template>

<script>
import header from "./components/public/header.vue";
import footer from "./components/public/footer.vue";
export default {
  name: "app",
  components: {
    "app-header": header,
    "app-footer": footer
  },
  data() {
    return {
      ready: false,
       Key: ''
    };
  },
  created() {
    this.$http.get("/Index/Config/data&key=default").then(res => {
      this.$store.commit("setWebConfig", res.value);
    });
    /* ----------------------------- */

   
  },
watch: {
   $route: function(newUrl, oldUrl) {
     this.Key = new Date().getTime();
   }
}
 
};
</script>

<style lang="less">
@import url("./assets/css/comm.less");

#app {
  padding-top: 100px;
}
@media (max-width: 768px) {
  #app {
    padding-top: 50px;
  }
}
</style>
